<template>
    <!-- 好友列表 -->
    <div class="help-alert-wrap flex-column" v-if="modalStatu=='friend'">
        <div class="help-alert flex-column helpFriend">
            <div class="help-alert-title">好友祝福</div>
            <div class="userInfoViwe">
                <div class="userInfo" v-for="(i,key) in helplist" v-bind:key="key">
                    <img class="userAvatar" :src="i.avatar" alt />
                    <p class="userNikeName">{{i.nickname}}</p>
                </div>
            </div>
        </div>
        <img @click="commHideModal('hide')" class="alert-close" src="../../static/images/alert_close.png" alt />
    </div>
</template>

<script>
export default {
  name: "FriendModal",
  props: ["modalStatu", "helplist"], //modalstatu 控制是否显示当前弹窗 helplist 好友列表数据
  data() {
    return {};
  },
  methods: {
    commHideModal(status) {
      this.$emit("commHideModal", status); //关闭当期弹窗  不在此组件内操作关闭动作，避免父级需要执行某些逻辑
    }
  }
};
</script>
<style scoped lang="scss" src="../../static/scss/helpme.scss"></style>
<style scoped lang="scss">
@import "../../static/scss/var.scss";
</style>